export const makeColorStrip = points => {
  return points.map(point => `${point.color} ${point.point}%`)
}
